import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, Component, OnDestroy, inject } from "@angular/core";
import { Store } from "@ngrx/store";

import { ticketState } from "@sports-features/ticket/stores";
import { TicketMobileSmallFooterComponent } from "@sports-pages/ticket/components/ticket-mobile-small-footer/ticket-mobile-small-footer";
import { TicketMethods } from "@sports-utils/index";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "ticket-mobile",
  templateUrl: "./ticket-mobile.html",
  styleUrls: ["./ticket-mobile.scss"],
  standalone: true,
  imports: [TicketMobileSmallFooterComponent, CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TicketMobileComponent implements OnDestroy {
  ticketState: ticketState;
  numberOfSelections: number = 0;
  store = inject(Store<ticketState>);

  private unsubscribe$ = new Subject<boolean>();

  constructor() {
    this.store
      .select("ticket")
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((ticketState: ticketState) => {
        this.ticketState = ticketState;
        this.numberOfSelections = TicketMethods.getNumberOfSelections(ticketState.ticket);
      });
  }

  showTMSmallFooter() {
    return this.numberOfSelections < 1;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
